import { useMemo } from "react";

const useIsDisabled = ({ record }) => {
  const disabled = useMemo(
    () =>
      record?.substitutive_declarations?.filter(
        (sd) => sd?.current_transaction?.state !== "draft"
      )?.length > 0,
    [record?.substitutive_declarations]
  );
  return disabled;
};

export default useIsDisabled;
